<h2 mat-dialog-title>Change Page Type</h2>

<mat-dialog-content class="page-type-dialog-content">
  <mat-form-field appearance="outline" class="page-type-field">
    <mat-label>Page type</mat-label>

    <mat-select [(ngModel)]="selectedPageType">
      @for (pageType of pageTypes; track pageType.value) {
        <mat-option [value]="pageType.value">
          {{ pageType.label }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    type="button"
    (click)="cancel()"
  >
    Cancel
  </button>

  <button
    mat-flat-button
    type="button"
    (click)="save()"
  >
    Save
  </button>
</mat-dialog-actions>